import Button from '@legacy-vfuk/core-button';
import CardCarousel from '@legacy-vfuk/core-card-carousel';
import Heading from '@legacy-vfuk/core-heading';
import React, { FC } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { useLocation } from '@reach/router';

import SWArticleCard from '../../Elements/SWArticleCard';
import { CardWrapper, RelatedArticlesCarouselWrapper, WrapButton, WrapSimpleGrid } from './SWRelatedArticles.styles';
import { SWRelatedArticlesProps } from './SWRelatedArticles.types';
import { set } from 'lodash';

const SWRelatedArticles: FC<SWRelatedArticlesProps> = ({ items = [] }: SWRelatedArticlesProps) => {

  const location = useLocation();

  const handleCLick = (e: React.MouseEvent) => {
    e.preventDefault();

    window.utag?.view({
      event_name: 'vhub knowledge center',
      event_label: 'vhub knowledge center',
      component_type: 'Button',
      event_category: location.pathname,
      event_action: 'Button Click',
    });

    setTimeout(() => {
      window.location.href = 'https://v-hub.vodafone.ie/knowledge-centre';
    }, 700);
  };
  return (
    <WrapSimpleGrid>
      {items && items.length > 0 ? (
        <RelatedArticlesCarouselWrapper>
          <CardCarousel
            id="relatedArticlesCarousel"
            slidesToShow={{ sm: 1, md: 2, lg: 3, xl: 3 }}
            slidesToScroll={{ sm: 1 }}
            srName="RelatedArticles Carousel"
          >
            {items.map(card => (
              <CardWrapper key={uuidv4()}>
                <SWArticleCard {...card} />
              </CardWrapper>
            ))}
          </CardCarousel>
        </RelatedArticlesCarouselWrapper>
      ) : (
        <CardWrapper>
          <Heading level={3} justify="center" text="No articles found" />
        </CardWrapper>
      )}
      <WrapButton>
        <Button text="Vhub Knowledge Center" appearance="alt1"  onClick={(e) => handleCLick(e)}/>
      </WrapButton>
    </WrapSimpleGrid>
  );
};

export default SWRelatedArticles;
